<template>
  <div class="wonderful-story __bc-f">
    <nav class="tip-title __fs-15 _fw-500">精选事件</nav>
    <swiper class="my-swiper-base" ref="videoSwiper" v-if="list.length" :options="swiperOption">
      <swiper-slide v-for="(item, index) in list" :key="index" :data-id="item.id" class="swiper-slide">
        <section @click="handleClickSlide(item)">
          <div v-if="item.bgVideo" class="item">
            <video class="video_back" :src="formatAliyunPath(item.bgVideo)" :poster="formatAliyunPath(item.bgVideo)+'?x-oss-process=video/snapshot,t_5000,f_jpg'" type="video/mp4" muted controls loop="loop"
              style="width:100%; height:100%; object-fit:fill" webkit-playsinline playsinline x5-video-player-type="h5-page">
            </video>
          </div>
          <div v-else-if="item.imgSrc" class="item">
            <img class="banner-img" :src="formatAliyunPath(item.imgSrc)" />
          </div>
          <div v-else class="item">
            <video class="video_back" src="@/assets/video/default.mp4" type="video/mp4" muted controls loop="loop"
            style="width:100%; height:100%; object-fit:fill" webkit-playsinline playsinline x5-video-player-type="h5-page">
            </video>
          </div>
          <div class="content">
            <p class="name">{{item.name}}</p>
            <p class="description">{{item.description}}</p>
          </div>
        </section>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'WonderfulStory',
  props: {
    list: {
      type: Array,
    }
  },
  data () {
    return {
      swiperOption: {
        slideActiveClass: 'my-swiper-base', // 类名
        loop: false, // 循环播放
        autoplay: true, // 自动播放
        centeredSlides: false,
        slidesPerView: 1.5, // 设置slider容器能够同时显示的slides数量
        spaceBetween: 25, // slide之间设置距离
        loopFillGroupWithBlank: true
      }
    }
  },
  methods: {
    // 点击swiper
    handleClickSlide (item) {
      this.$emit('handle-click-wonderful', item)
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  },
}
</script>

<style scoped lang="scss">
.wonderful-story {
  padding: 44px 0 28px 20px;
  box-sizing: border-box;
  margin-bottom: 25px;
  width: 100%;
  .tip-title {
    padding-left: 8px;
    border-left: 2px solid $main-color;
    color: #282828;
    margin-bottom: 25px;
  }
  .swiper-slide{
    height: 100%;
    .item{
      width: 230px;
      height: 132px;
      overflow: hidden;
      img{
        display: block;
        width:  100%;
        height: auto;
      }
    }
    .content{
      padding: 20px 10px;
      box-sizing: border-box;
      .name{
        opacity: 1;
        font-size: 17px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: left;
        color: #252525;
        margin-bottom: 10px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .description{
        opacity: 1;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: left;
        color: #828282;
        line-height: 18px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}
</style>
